import script from "./MainMenuHorizontal.vue?vue&type=script&setup=true&lang=js"
export * from "./MainMenuHorizontal.vue?vue&type=script&setup=true&lang=js"

import "./MainMenuHorizontal.vue?vue&type=style&index=0&id=5a546450&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a546450"]])

export default __exports__